





































































import { Vue, Component, Mixins } from "vue-property-decorator";
import MyList from "@/mixins/list";

import Add from "./category_add.vue";
import Edit from "./category_edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "workorders/categorylist";

  deleteConfirmContent = "你确定要删除该分类吗？";

  dispatchTypeDelete = "workorders/deletecategory";

  apps: any[] = [];

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "类型名称", dataIndex: "category_name" },
    { title: "app", dataIndex: "app_id" },
    { title: "排序号", dataIndex: "sortid" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData();
    this.loadApps();
  }

  async loadApps() {
    const res = await this.$store.dispatch("api/getApplist", {});
    if (res && res.Data && res.Data !== "{}") {
      this.apps = res.Data;
    }
  }
}
